module.exports = __webpack_public_path__ + "img/471.d0554a85.jpg";